import { ValueOf } from '@/types/util';

// Bodyにはエラーメッセージを定義
export const EAccountPasswordCharacterType = {
  ALPHANUMERIC_UPPERCASE_LOWERCASE_REQUIRED: '（英字の大文字、小文字、数字は各々1つ以上含む）',
  ALPHANUMERIC_ANYCASE: '（英字、数字は各々1つ以上含む）',
} as const;

export type AccountPasswordCharacterType = keyof typeof EAccountPasswordCharacterType;
export type AccountPasswordCharacterValue = ValueOf<typeof EAccountPasswordCharacterType>;
